export var OpcoesBanco = [
    {
        Value: "001",
        Name: "001 - BANCO DO BRASIL"
    },
    {
        Value: "033",
        Name: "033 - SANTANDER"
    }
];